import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toHtml from "html-react-parser";
import Breadcrums from "../../common/breadcrumbs";
import Loader from "../../common/loader";
import { breakWord, capitalizeFirstLetter, formateDate, showStatus } from "../../../../utils/commonfunction";
import * as subscriptionServices from "../../services/subscription.services";
import { useTranslation } from "react-i18next";

const SubscriptionView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("link_subscription"), url: "/admin/subscriptionManagement/list/1" },
    { title: t("link_view"), url: "" },
  ];

  // const selected_language = localStorage.getItem("system_language")
  // console.log(selected_language)

  useEffect(() => {
    subscriptionServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, []);


  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("heading_subscription_view")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table  table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("list_heading_title")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.title ? showdefault.title : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("list_heading_price")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.price !== null && showdefault?.price !== undefined ? showdefault.price : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_status")}</th>
                          <td>{showdefault && showdefault?.status === 0 ? toHtml(showStatus(showdefault.status)) : toHtml(showStatus(showdefault.status))}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_duration_type")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.duration_type ? showdefault.duration_type : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("subscription_access")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && Array.isArray(showdefault?.subscription_access) && showdefault.subscription_access.length > 0
                              ? showdefault.subscription_access
                                .map((access) => {
                                  if (access && typeof access === "object" && !Array.isArray(access)) {
                                    const label = access.label ? `${access.label}`.trim() : "";
                                    const value = access.value ? `${access.value}`.trim() : "";
                                    if (label && value) return `${label}: ${value}`;
                                    if (label) return label;
                                    if (value) return value;
                                    return null;
                                  }

                                  if (typeof access === "string") return access.trim();
                                  return null;
                                })
                                .filter(Boolean)
                                .join(", ") || "N/A"
                              : [showdefault?.ai_usage_limit, showdefault?.item_limit, showdefault?.post_limit, showdefault?.outfit_limit].some(
                                (value) => value !== null && value !== undefined && value !== ""
                              )
                                ? [
                                  showdefault?.ai_usage_limit ? `${t("label_ai_usage_limit")}: ${showdefault.ai_usage_limit}` : null,
                                  showdefault?.item_limit ? `${t("item_limit")}: ${showdefault.item_limit}` : null,
                                  showdefault?.post_limit ? `${t("post_limit")}: ${showdefault.post_limit}` : null,
                                  showdefault?.outfit_limit ? `${t("outfit_limit")}: ${showdefault.outfit_limit}` : null,
                                ]
                                  .filter(Boolean)
                                  .join(", ")
                                : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("label_benefits")} </th>
                          <td className="text-capitalize" style={{ wordBreak: "break-word" }}>
                            {showdefault && showdefault?.benefits && showdefault.benefits.length > 0
                              ? (Array.isArray(showdefault.benefits) ? showdefault.benefits.join(', ') : showdefault.benefits)
                              : "N/A"}
                          </td>
                        </tr>

                        {/* <tr>
                          <th>{t("label_sub_category")}</th>
                          <td>
                            {showdefault?.subCategories?.length > 0
                              ? showdefault.subCategories.map((sub, index) => (
                                  <span key={sub._id}>
                                    {sub.title.split(" ")}
                                    {index < showdefault.subCategories.length - 1 ? ", " : ""}
                                  </span>
                                ))
                              : "-"}
                          </td>
                        </tr> */}

                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault && showdefault.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_modified_date")}</th>
                          <td>{showdefault && showdefault?.updatedAt ? formateDate(showdefault.updatedAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    {/* <h6 className="main-content-label mb-3">{t("label_description")}:</h6> */}
                    {/* <div className="">{toHtml(showdefault && showdefault.description ? showdefault.description : "N/A")}</div> */}
                    {/* <div
                      className="text-capitalize"
                      dangerouslySetInnerHTML={{
                        __html: showdefault && showdefault?.description ? showdefault.description : "N/A",
                      }}></div> */}
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SubscriptionView;
